import React, { ReactNode } from "react";
import { ReferenciaPlantillaContenido } from "interfaces/ReferenciaPlantillaContenido";

import "./mentorsCard.scss"

interface MentorsCardInterface {
    name: string,
    description: string | ReactNode,
    location: string,
    imgUrl: string,
    ctaAction?: (cardInfo : ReferenciaPlantillaContenido ) => void,
    ctaInfo?: ReferenciaPlantillaContenido
};

const MentorsCard = ({name, description, location, imgUrl, ctaAction, ctaInfo} : MentorsCardInterface) => {

    return (
        <div className="a-mentors-card">
            <img src={imgUrl} className="a-mentors-card__img"/>
            <div className="a-mentors-card__text-divider">
                <div className="a-mentors-card__text-container">
                    <span className="a-mentors-card__name">{name}</span>
                    {description}
                    <span className="a-mentors-card__location">{`${location}`}</span>
                </div>
            </div>
            <button className="a-mentors-card__anchor" onClick={() => {ctaAction && ctaInfo && ctaAction(ctaInfo)}}>¡Conoce más!</button>
        </div>
    );
};

export default MentorsCard;